import React, { useState } from 'react';
import Button from 'view/common/elements/button';
import { InputText } from 'view/common/elements/input';
import Upload from 'view/common/elements/upload';

const BulkUpload = (props) => {

  const [batchName, setBatchName] = useState("");
  const [batchNameError, setBatchNameError] = useState("");

  const [fileUploading, setFileUploading] = useState(false);

  const [fileSelected, setFileSelected] = useState(false);

  const onBatchNameChange = (e) => {

  }

  const uploadFile = ()  => {
    setFileUploading(true);
  }

  const onUploadSuccess = (key) => {
    setFileUploading(false);
    console.log("success", key)
    
    props.onUploadSuccess(key, batchName);
    setBatchName("");
  }

  const onUploadError = (p1, p2) => {
    setFileUploading(false);
    console.log("err")
    console.log(p1, p2)
  }

  return ( 
    <div>
      {/* <div>New Upload</div> */}
      <div className='flex justify-between items-center'>
        <div className='w-1/3'>
          <InputText
            value={batchName}
            name="batchName" 
            id="batchName" 
            onChange={setBatchName}
            placeholder="Batch Name"
            error={batchNameError}
            onFocus={()=>{setBatchNameError("")}}
            className={"mb-2 padded"}
          />
        </div>

        <div className='ml-2 mb-2 w-1/3'>

          
          <Upload
            accept={'.csv'}
            onUploadSuccess={onUploadSuccess}
            onUploadError={onUploadError}
            canUploadFile={fileUploading}
            onFileSelect={()=>{setFileSelected(true)}}
          />

        </div>
        <div className='text-right mb-2 w-1/3'>
          <Button
            className={`inline-block`}
            text={"Create batch"}
            loading={fileUploading}
            onClick={uploadFile}
            disabled={!fileSelected || batchName === "" }
          />
        </div>
      </div>
    </div>
  ) 
}

export default BulkUpload;